// extracted by mini-css-extract-plugin
export default {"title":"LocationLiveTrackTitle_title__3dp-D"};